// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_9x-0";
export var optionCard = "_9x-1";